<template>
  <div class="pie">
    <div id="epidemicPersonnelItems" class="epidemicPersonnelItems" :style="{width: width, height: height}" ></div>
    <div class="pie-right">
        <div>
            <div class="pie-percentage hubei" @click="toEpidemicSituationRegisterPage('1')">
                <span>湖北</span>
                <el-progress v-if="hb !== 0" :percentage="(hbReturn / hb).toFixed(2) * 100" color="#5B9BD5" style="flex:1" :format="hbFormat"></el-progress>
                <el-progress v-else :percentage="0" :format="hbFormat" color="#5B9BD5" style="flex:1"></el-progress>
            </div>
            <div class="pie-return hubei" @click="toTemperaturePage('1')">返回园区人数：{{hbReturn}}</div>
        </div>
        <div>
            <div class="pie-percentage wenzhou" @click="toEpidemicSituationRegisterPage('2')">
                <span>温州</span>
                <el-progress v-if="wz !== 0" :percentage="(wzReturn / wz).toFixed(2) * 100" color="#ED7D31" style="flex:1" :format="wzFormat"></el-progress>
                <el-progress v-else :percentage="0" :format="wzFormat" color="#ED7D31" style="flex:1"></el-progress>
            </div>
            <div class="pie-return wenzhou" @click="toTemperaturePage('2')">返回园区人数：{{wzReturn}}</div>
        </div>
        <div>
            <div class="pie-percentage taizhou" @click="toEpidemicSituationRegisterPage('3')">
                <span>台州</span>
                <el-progress v-if="tz !== 0" :percentage="(tzReturn / tz).toFixed(2) * 100" color="#FFC000" style="flex:1" :format="tzFormat"></el-progress>
                <el-progress v-else :percentage="0" :format="tzFormat" color="#FFC000" style="flex:1"></el-progress>
            </div>
            <div class="pie-return taizhou" @click="toTemperaturePage('3')">返回园区人数：{{tzReturn}}</div>
        </div>
        <div>
            <div class="pie-percentage ningbo" @click="toEpidemicSituationRegisterPage('4')">
                <span>宁波</span>
                <el-progress v-if="nb !== 0" :percentage="(nbReturn / nb).toFixed(2) * 100" color="#A5A5A5" style="flex:1" :format="nbFormat"></el-progress>
                <el-progress v-else :percentage="0" :format="nbFormat" color="#A5A5A5" style="flex:1"></el-progress>
            </div>
            <div class="pie-return ningbo" @click="toTemperaturePage('4')">返回园区人数：{{nbReturn}}</div>
        </div>
    </div>
  </div>
</template>

<script>
  import {errorHandler} from '../../../../utils/errorHandler'
  import {api} from '../../../../view/api/epidemicSituation'

  export default {
    name: 'epidemic-personnel-pie',
    props: {
      width: {
        type: String,
        default () {
          return '50%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      buildingCode: {
        type: String,
        default () {
          return ''
        }
      },
    },
    data () {
      return {
        chartText: '电表',
        tipData: ['湖北', '温州', '台州', '宁波'],
        chartData: [],
        totalCount: '',

        // 疫区分布
        hb: 0,
        hbReturn: 0,
        tz: 0,
        tzReturn: 0,
        wz: 0,
        wzReturn: 0,
        nb: 0,
        nbReturn: 0,
      }
    },
    created () {},
    mounted () {
      this.keyAreaCount()
    },
    methods: {
      hbFormat(percentage) {
        return this.hb || '0'
      },
      wzFormat(percentage) {
        return this.wz || '0'
      },
      tzFormat(percentage) {
        return this.tz || '0'
      },
      nbFormat(percentage) {
        return this.nb || '0'
      },
      // 获取疫区分布
      keyAreaCount () {
        this.$axios.post(api.keyAreaCount, {})
          .then(res => {
            let data = res.data.data
            this.hb = data.hb || 0
            this.hbReturn = data.hbReturn || 0
            this.tz = data.tz || 0
            this.tzReturn = data.tzReturn || 0
            this.wz = data.wz || 0
            this.wzReturn = data.wzReturn || 0
            this.nb = data.nb || 0
            this.nbReturn = data.nbReturn || 0
            this.drawPie()
          })
          .catch(errorHandler('获取数据失败'))
        
      },
      drawPie () {
        let epidemicPersonnelItems = this.$echarts.init(document.getElementById('epidemicPersonnelItems'))
        epidemicPersonnelItems.setOption({
          title : {
            text: '企业员工重点疫区分布情况',
            trigger: 'item',
            left: 'center',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          tooltip : {
            trigger: 'item',
            formatter (data) {
              return `${data.name}:${data.value}`
            },
            // formatter: `{b} : {c} \n ({d}%)`,
          },
          legend: {
            left: 'center',
            bottom: 5,
            data: this.tipData
          },
          color: ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5'],
          series : [
            {
              name: '',
              type: 'pie',
              radius: ['50%', '70%'],
              data: [
                  {value: this.hb, name: '湖北'},
                  {value: this.wz, name: '温州'},
                  {value: this.tz, name: '台州'},
                  {value: this.nb, name: '宁波'},
              ],
              label: {
                normal: {
                  show: false,
                //   formatter (data) {
                //     return `${data.name}\n${data.value}`
                //   },
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '12',
                    }
                }
              },
              labelLine: {
                normal: {
                    show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        });

      },

      // 跳转防疫登记页面
      toEpidemicSituationRegisterPage (data) {
        this.$router.push({
          path: `/epidemic_situation_register/${data}`
        })
      },

      // 跳转体温监测页面
      toTemperaturePage (data) {
        this.$router.push({
          path: `/temperature/${data}`
        })
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .pie {
    width: 100%;
    display: flex;
    justify-content: space-between
  }
  .pie-right {
      width: 50%;
      display: flex;
      justify-content: center;
      flex-direction: column;
  }
  .pie-percentage {
      display: flex;
      justify-content: flex-start;
  }
  .pie-return {
      margin-bottom: 10px;
  }
  .hubei:hover {
    cursor: pointer;
    color: #5B9BD5;
  }
  .wenzhou:hover {
    cursor: pointer;
    color: #ED7D31;
  }
  .taizhou:hover {
    cursor: pointer;
    color: #FFC000;
  }
  .ningbo:hover {
    cursor: pointer;
    color: #A5A5A5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Pie/Pie/epidemicPersonnelPie.vue